// Copyright (c) 2020 Deere & Company

import { IntlProvider } from 'react-intl';
import React from 'react';
import { connect } from 'react-redux';

const CustomIntlProvider = props => (
    <IntlProvider
        {...props}
        onError={( err ) => {
            // Suppress missing translation warnings
            const errorMessage = err && err.message ? err.message : String( err );
            if ( err && err.code === 'MISSING_TRANSLATION' ) {
                return;
            }
            if ( errorMessage.includes( 'Missing message' ) ) {
                return;
            }
            if ( errorMessage.includes( 'Cannot format message' ) ) {
                return;
            }
            console.error( err );
        }}
    />
);

const getStateToBindToContainerProps = () => ( {
    locale: 'EN'
} );

export default connect( getStateToBindToContainerProps )( CustomIntlProvider );
